import React, { Component } from "react";
import { Form, Col, Row, Button, Table, InputGroup } from "react-bootstrap";
import { Redirect } from "react-router";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import { Multiselect } from "multiselect-react-dropdown";
import RetailDiscountCouponDetail from "./RetailDiscountCouponDetail";
import "../../assets/styles/RetailPortal.css";
import { get, post, sess_get, sess_post } from "../../utils/HttpRequests";

class RetailPortal extends Component {
  constructor() {
    super();
    this.state = {
      code: "DO*****",
      name: "",
      branch: "",
      city: "",
      pincode: "",
      poc_name: "",
      poc_contact: "",
      state: "",
      active: false,
      plans: [],
      start_date: new Date(),
      expiry_date: new Date(),
      error: {
        code: "",
        numbers: "",
      },
      isSubmitting: false,
      hasErrors: false,
      percentage: 0,
      percentageCap: 0,
      type: "flat",
      flat: 0,
      planType: "all",
      allPlans: [],
      quantity: 0,
    };
  }

  async componentDidMount() {
    const session_token = localStorage.getItem("admin-panel-sessionToken");
    let plans = await sess_get("admin/console/get-plans", session_token);
    let allPlans = [];
    if (
      plans &&
      plans.data &&
      plans.data.response &&
      plans.data.response.plans
    ) {
      plans = plans.data.response.plans;
    } else {
      plans = [];
    }
    plans.forEach((p) => (p.quantity = 0));
    allPlans = plans;
    this.setState({
      ...this.state,
      plans,
      allPlans,
    });
  }

  hasErrors() {
    let { error } = this.state;
    for (let i in error) {
      if (error[i]) {
        return true;
      }
    }
    return false;
  }

  setErrorStatus() {
    let hasErrors = this.hasErrors();
    this.setState({
      ...this.state,
      hasErrors,
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({
      ...this.state,
      isSubmitting: true,
    });
    this.createRetailStore().then((d) => {
      if (d && d.error) {
        this.setState({
          ...this.state,
          isSubmitting: false,
        });
        toast.error(`We were unable to add the store,${d.error}`, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      } else {
        this.props.history.push("/retail");
        toast.success("Coupon Added!", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    }).catch(error => {
      // console.log(error);
    })
  };

  createRetailStore = async () => {
    const session_token = localStorage.getItem("admin-panel-sessionToken");

    let { plans } = this.state;
    if (!plans || !plans.length) {
      plans = null;
    }
    return sess_post("admin/console/retail-portal", session_token, this.state)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err && err.response && err.response.data) {
          let { error } = err.response.data;
          console.error(error);
          return { error: error.reason };
        }
        return { error: err.toString() };
      });
  };

  handleOnChange = (ev, d) => {
    let val = ev.target.value;
    let id = ev.target.id;

    let { error } = this.state;
    error[id] = "";
    let codeError = "";
    if (!val) {
      error[id] = "Must not be empty";
    }
    if (id === "code" && (val.length < 6 || val.length > 20)) {
      error[id] = "Code Length must be between 6 and 30 characters long";
    }
    if (id === "pincode" && (val.length < 6 || val.length > 6)) {
      error[id] = "pin code invalid";
    }

    this.setState(
      {
        ...this.state,
        [ev.target.id]: ev.target.value,
        error,
      },
      this.setErrorStatus
    );
  };

  handlePlan = (ev, plan) => {
    let { plans } = this.state;
    plans.forEach((p) => {
      if (p._id === plan._id) {
        p.quantity = ev.target.value;
      }
    });

    this.setState({
      ...this.state,
      plans,
    });
  };

  handleActiveChange = async (event) => {
    let active = event.target.checked;
    this.setState({
      ...this.state,
      active,
    });
  };

  handleDiscountType = async (event) => {
    let type = event.target.value;
    let state = {
      ...this.state,
    };
    state.type = type;
    if (type == "flat") {
      state.percentage = 0;
      state.percentageCap = 0;
    } else if (type == "percentage") {
      state.flat = 0;
    }
    this.setState({ ...state });
  };

  handleFlatChange = async (event) => {
    let flat = event.target.value;
    if (flat < 0) flat = 0;
    this.setState({
      ...this.state,
      flat,
    });
  };

  handlePercentageChange = async (event) => {
    let percentage = event.target.value;
    if (percentage < 0) {
      percentage = 0;
    } else if (percentage > 100) {
      percentage = 100;
    }
    this.setState({
      ...this.state,
      percentage,
    });
  };

  handlePercentageCapChange = async (event) => {
    let percentageCap = event.target.value;
    if (percentageCap < 0) {
      percentageCap = 0;
    }
    this.setState({
      ...this.state,
      percentageCap,
    });
  };

  handlePlanType = async (event) => {
    this.setState({
      ...this.state,
      plans: this.state.allPlans,
      quantity: 0,
      [event.target.id]: event.target.value,
    });
  };

  handleAssignCouponsToAllPlans = async (event) => {
    const quantity = event.target.value;
    const { allPlans } = this.state;
    const plans = allPlans.map((plan) => {
      return { ...plan, quantity };
    });
    this.setState({
      ...this.state,
      quantity,
      plans,
    });
  };

  render() {
    let {
      code,
      name,
      branch,
      city,
      pincode,
      poc_name,
      poc_contact,
      state,
      active,
      error,
      plans,
      start_date,
      expiry_date,
      isSubmitting,
      hasErrors,
      percentage,
      percentageCap,
      type,
      flat,
      entity,
    } = this.state;
    return (
      <div className="retail-portal-container">
        <div className="header">
          <div>Add Retail Store</div>
          {/* <button onClick={this.redirectToCoupon('new')}>+</button> */}
        </div>
        <Form onSubmit={this.handleSubmit} className="form-container">
          <Form.Group controlId="entity">
            <Form.Label>Entity Name</Form.Label>
            <Form.Control
              onChange={this.handleOnChange}
              value={entity}
              type="text"
              name="entity"
            />
            <Form.Text className={"error-label"}>{error["entity"]}</Form.Text>
          </Form.Group>
          <Form.Group controlId="name">
            <Form.Label>Store Name</Form.Label>
            <Form.Control
              onChange={this.handleOnChange}
              value={name}
              type="text"
              name="name"
            />
            <Form.Text className={"error-label"}>{error["name"]}</Form.Text>
          </Form.Group>
          <Form.Group controlId="city">
            <Form.Label>City</Form.Label>
            <Form.Control
              onChange={this.handleOnChange}
              value={city}
              type="text"
              name="city"
            />
            <Form.Text className={"error-label"}>{error["city"]}</Form.Text>
          </Form.Group>
          <Form.Group controlId="branch">
            <Form.Label>Branch</Form.Label>
            <Form.Control
              onChange={this.handleOnChange}
              value={branch}
              type="text"
              name="branch"
            />
            <Form.Text className={"error-label"}>{error["branch"]}</Form.Text>
          </Form.Group>
          <Form.Group controlId="pincode">
            <Form.Label>Pincode</Form.Label>
            <Form.Control
              onChange={this.handleOnChange}
              value={pincode}
              type="text"
              name="pincode"
            />
            <Form.Text className={"error-label"}>{error["pincode"]}</Form.Text>
          </Form.Group>{" "}
          <Form.Group controlId="poc_name">
            <Form.Label>POC Name</Form.Label>
            <Form.Control
              onChange={this.handleOnChange}
              value={poc_name}
              type="text"
              name="poc_name"
            />
            <Form.Text className={"error-label"}>{error["poc_name"]}</Form.Text>
          </Form.Group>
          <Form.Group controlId="poc_contact">
            <Form.Label>POC Contact No</Form.Label>
            <Form.Control
              onChange={this.handleOnChange}
              value={poc_contact}
              type="text"
              name="poc_contact"
            />
            <Form.Text className={"error-label"}>
              {error["poc_contact"]}
            </Form.Text>
          </Form.Group>
          <Form.Group controlId="state">
            <Form.Label>State</Form.Label>
            <Form.Control
              onChange={this.handleOnChange}
              value={state}
              type="text"
              name="state"
            />
            <Form.Text className={"error-label"}>{error["state"]}</Form.Text>
          </Form.Group>
          <RetailDiscountCouponDetail {...this} />
        </Form>
      </div>
    );
  }
}

export default withRouter(RetailPortal);
